import { render } from "./ca-smtt-card.vue?vue&type=template&id=08afcc2e"
import script from "./ca-smtt-card.vue?vue&type=script&lang=js"
export * from "./ca-smtt-card.vue?vue&type=script&lang=js"

import "./ca-smtt-card.vue?vue&type=style&index=0&id=08afcc2e&lang=css"

import exportComponent from "/home/saes/central_authentication/central_authentication_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__